import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { environment } from 'src/environments/environment';
import {Buffer} from 'buffer';
import { IOrganisationInfo } from '../shared/interfaces';
import { ILoginRequest } from '../shared/interfaces/general.interface';

@Injectable()
export class AuthenticationService {

  constructor(private _http: HttpClient) { }

  login(username: string, password: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    });
    const url = `${environment.idam_api_url}/api/v1/auth/login`;
    return this._http.post<any>(url, JSON.stringify({ username: username, password: password }), { observe: 'response', headers: headers });
  }

  loginWithAuthenticatingOrganisation(username: string, password: string, organisationId: string , twoFaCode?: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1',
      'x-ui-page': ''
    });
    const url = `${environment.gateway_api_url}/api/v1/auth/login`;
    return this._http.post<any>(url, JSON.stringify({ username: username, password: password, organisationId: organisationId, twoFaCode: twoFaCode}), { observe: 'response', headers: headers });
  }

  loginSpecificPlace(username: string, password: string, organisationId: string): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    });
    const url = `${environment.idam_api_url}/api/v1/auth/login-specific-organisation?organisation=${organisationId}&tenant=tenant1`;
    return this._http.post<any>(url, JSON.stringify({ username: username, password: password }), { observe: 'response', headers: headers });
  }

  logout() {
    localStorage.removeItem('currentUser');
  }

  samlRequest(key: any): Observable<HttpResponse<any>> {
    const jwt: any = JSON.parse(localStorage.getItem('currentUser'));
    const url: string = `${environment.idam_api_url}/api/v1/saml/sso-request?token=${key}`;
    const headers = new HttpHeaders();
    headers.set('Authorization', 'Bearer ' + jwt.token);
    return this._http.get(url, { observe: 'response', responseType: 'text', headers: new HttpHeaders({ 'Content-Type': 'application/json;charset=UTF-8', 'Authorization': 'Bearer ' + jwt.token }) });
  }

  redirect(url: string) {
    const parseUrl = (string, prop) => {
      const a = document.createElement('a');
      a.setAttribute('href', string);
      const { host, hostname, pathname, port, protocol, search, hash } = a;
      const origin = `${protocol}//${hostname}${port.length ? `:${port}` : ''}`;
      return prop ? eval(prop) : { origin, host, hostname, pathname, port, protocol, search, hash }
    };
    // if (url?.includes('?')) {
    //   /**
    //    * this forces the returnUrll to remove any queryParams cuz it messes with the params passed by identity
    //    */
    //   const splittedUrl: string[] = url.split("?");
    //   if (!HelperFunctions.IsEmptyOrUndefined(splittedUrl)){
    //     url = splittedUrl[0]
    //   }
    // }
    const encodedUrl = Buffer.from(url, 'utf-8').toString('base64')
    const fullRedirectUrl = `${parseUrl(url, 'origin')}/auth?encodedUrl=${encodedUrl}&d=${btoa(localStorage.getItem('currentUser').toString())}`
    window.location.href = fullRedirectUrl?.toString();
  }

  redirectWithToken(url: string, token: string) {
        const parseUrl = (string, prop) => {
      const a = document.createElement('a');
      a.setAttribute('href', string);
      const { host, hostname, pathname, port, protocol, search, hash } = a;
      const origin = `${protocol}//${hostname}${port.length ? `:${port}` : ''}`;
      return prop ? eval(prop) : { origin, host, hostname, pathname, port, protocol, search, hash }
    };
    // if (url?.includes('?')) {
    //   /**
    //    * this forces the returnUrll to remove any queryParams cuz it messes with the params passed by identity
    //    */
    //   const splittedUrl: string[] = url.split("?");
    //   if (!HelperFunctions.IsEmptyOrUndefined(splittedUrl)){
    //     url = splittedUrl[0]
    //   }
    // }
    const encodedUrl = Buffer.from(url, 'utf-8').toString('base64')
    const fullRedirectUrl = `${parseUrl(url, 'origin')}/auth?encodedUrl=${encodedUrl}&d=${token}`
    window.location.href = fullRedirectUrl?.toString();
  }

  samlSsoRequest(baseUrlRequest: string, orgId: string, method: string, queryParam: string, body?: any) {
    let baseUrl = ''
    if (baseUrlRequest) {
      const pathArray = baseUrlRequest.split('/');
      const protocol = pathArray[0];
      const host = pathArray[2];
      baseUrl = protocol + '//' + host;
    }
    const url = baseUrl ? `${baseUrl}/saml/sso${queryParam}` : `${environment.idam_api_url}/${orgId}/saml/sso${queryParam}`;
    if (method == 'POST') {
      this.submitForm(url, method, body)
      // return this._http.post(url, body, { headers: new HttpHeaders({'Accept': '*/*', 'Content-Type': 'application/x-www-form-urlencoded'}), observe: 'response', responseType: 'text', withCredentials: true })
    } else {
      window.location.href = url
    }
    return of()
  }

  submitForm(action, method, params) {
    const urlParams = new URLSearchParams(params);
    const entries = Object.fromEntries(urlParams);
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
    form.action = action;
    let input;
    for (const [key, value] of Object.entries(entries)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  }

  samlSsoRequestWithoutOrg(method: string, queryParam: string, body?: any) {
    const url = `${environment.idam_api_url}/saml/sso${queryParam}`;
    if (method == 'POST') {
      return this._http.post(url, body, { headers: new HttpHeaders({'Accept': '*/*', 'Content-Type': 'application/x-www-form-urlencoded'}), observe: 'response', responseType: 'text', withCredentials: true })
    }
    return this._http.get(url, { observe: 'response', responseType: 'text', withCredentials: true  });
  }

  public getOrganisationInfo(organisationId: string): Observable<IOrganisationInfo> {
    const url = `${environment.idam_api_url}/public/api/v1/organisations/${organisationId}?tenant=tenant1`;
    let response = this._http.get<IOrganisationInfo>(url);
    return response;
  }

  public emailPasswordLogin(body: ILoginRequest): Observable<any> {
        const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    });
    return this._http.post<any>(`${environment.idam_api_url}/api/v2/auth/login/email`, body, {headers: headers});
  }

}
